import {CurrentProjectResource} from 'common/report/model-resources/projects';
import {
  bulkDeleteMetrics as apiBulkDeleteMetrics,
  updateMetric as apiUpdateMetric,
} from 'common/report/queries/app-api/metrics';
import {Metric} from 'app_api/projects/metrics/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {MetricsResource} from 'common/report/model-resources/metrics';
import {isFirstClassMetricsEnabled} from 'common/report/util/feature-sampling';

export async function updateMetric({
  resource,
  metric,
  props,
}: {
  resource: MetricsResource;
  metric: Metric;
  props: Partial<Metric>;
}) {
  try {
    resource.update({[metric.id!]: {...metric, ...props} as Partial<Metric>});
    const results = await apiUpdateMetric({
      metricId: metric.id!.toString(),
      metric: props,
    });
    resource.update(results);
    return true;
  } catch {
    addToast({message: `Your change could not be saved.`, type: ToastType.ERROR});
    resource.update({[metric.id!]: metric});
    return false;
  }
}

export async function deleteMetrics({resource, metrics}: {resource: MetricsResource; metrics: Metric[]}) {
  try {
    await apiBulkDeleteMetrics(metrics);
    resource.update(Object.fromEntries(metrics.map((metric) => [metric.id, null])));
    return true;
  } catch {
    addToast({message: `Your changes could not be saved.`, type: ToastType.ERROR});
    return false;
  }
}

export function hasFirstClassMetrics(currentProject: CurrentProjectResource) {
  return Boolean(isFirstClassMetricsEnabled(currentProject?.get?.()?.value ?? null));
}
